module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_ControlsAndSettings_16"],"path":[{"$":{"d":"M3,1H1V3H0V7H1v8H3V7H4V3H3ZM1,4H3V6H1ZM9,1H7V9H6v4H7v2H9V13h1V9H9ZM7,10H9v2H7Zm8-5V1H13V5H12V9h1v6h2V9h1V5ZM13,6h2V8H13Z"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_ControlsAndSettings_16.svg
// module id = L0Sd
// module chunks = 1